import get from 'lodash/get'
import { Typography, Box, Divider, Menu, MenuItem } from '@mui/material'
import { isUndefined } from 'src/helper/isUndefined'
import { isStatus } from 'src/components/pages/sales/reservation/helper/isStatus'
import { useRecordContext } from 'react-admin'
import { formatDate, formatDateTime } from 'src/components/pages/sales/business-rule/helper/formatDate'
import { useTranslate } from 'react-admin'
import { ArrowRight } from '@mui/icons-material'
import { useState } from 'react'
import { PERMISSION_FRAUD } from 'src/helper/Permission'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { LoadingButton } from '@mui/lab'

export const ShowElement = ({
  source,
  label,
  strong = false,
  blueText = false,
  weightMoney = false,
  data,
  boolean = false,
  icon = false,
  styleValue,
  style = { padding: '5px 0px 5px 0px' },
  onlyValue = false,
  date = false,
  dateTime = false,
  dateFormatCustom = undefined,
  actionButton = undefined,
  monetarySymbol,
  status = false,
  disabled = false,
  loading = false,
  onSelectOption = null
}) => {
  const translate = useTranslate()
  const record = useRecordContext()
  const value = source ? get(record, source) : data
  const [anchorEl, setAnchorEl] = useState(null)

  const evaluateProps = () => {
    const valueAux = value !== null ? value : status ? 'UNPAID' : null
    if (valueAux !== null || valueAux !== undefined || valueAux !== '') {
      if (boolean) {
        if (valueAux) return 'Si'
        return 'No'
      } else if (status || label === 'status' || label === 'Estado' || source === 'status') {
        const statusTranslate = translate(`ra.status.${valueAux}`)
        return statusTranslate.includes('.') ? valueAux : statusTranslate
      } else if (monetarySymbol) {
        return `${monetarySymbol} ${valueAux}`
      } else if (weightMoney) {
        return `$${valueAux}`
      } else if (icon) {
        return (
          <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
            <div>{icon} </div>
            {dateFormatCustom ? (
              <div>{valueAux ? dateFormatCustom(valueAux) : ''}</div>
            ) : (
              <div>{valueAux ? isUndefined(valueAux) : ''}</div>
            )}
          </Box>
        )
      } else if (date) {
        return formatDate(valueAux)
      } else if (dateTime) {
        return formatDateTime(valueAux)
      } else if (dateFormatCustom) {
        return dateFormatCustom(valueAux)
      }
    }

    return isUndefined(valueAux)
  }

  const hasStyleValue = () => {
    let styleValueAux = styleValue ? { ...styleValue } : {}

    if (!styleValue?.color) {
      styleValueAux.color = blueText ? 'blue' : 'black'
    }

    if (!styleValue?.fontWeight) {
      styleValueAux.fontWeight = strong ? 'bold' : 'normal'
    }

    return styleValueAux
  }

  const isClickable = () => {
    return status && value === 'IN_REVIEW' && hasPermissionFunction('item', PERMISSION_FRAUD)
  }

  const onClickElement = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleSelectOption = (value) => {
    setAnchorEl(null)
    onSelectOption && onSelectOption(record, value)
  }

  return (
    <Box style={style} display={'flex'} alignItems={'center'}>
      {!onlyValue && (
        <Typography
          variant='h7'
          component='span'
          style={{
            padding: '0px 5px 0px 5px',
            fontWeight: 600,
            flex: 1,
            maxWidth: 'fit-content'
          }}
        >
          {label}:
        </Typography>
      )}

      {isClickable() ? (
        <LoadingButton
          className='element-button'
          style={{
            ...hasStyleValue(),
            ...isStatus(label, value, status, disabled || loading),
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            minWidth: '50px'
          }}
          disabled={disabled}
          loading={loading}
          onClick={onClickElement}
        >
          {evaluateProps()}

          <HasPermission resource='item' permission={PERMISSION_FRAUD}>
            {status && value === 'IN_REVIEW' && (
              <>
                <Divider
                  orientation='vertical'
                  flexItem
                />
                <ArrowRight
                  style={{
                    fontSize: 20,
                    margin: '2px 0px'
                  }}
                />
              </>
            )}
          </HasPermission>
        </LoadingButton>
      ): (
        <Typography
          variant='h7'
          component='div'
          style={{
            ...hasStyleValue(styleValue),
            ...isStatus(label, value, status),
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            minWidth: '50px',
          }}
        >
          {evaluateProps(value)}
        </Typography>
      )}

      {actionButton && actionButton}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => handleSelectOption('approve')}>
          {translate('ra.action.approve')?.toUpperCase()}
        </MenuItem>
        <Divider style={{ margin: 0 }} />
        <MenuItem onClick={() => handleSelectOption('refuse')}>
          {translate('ra.action.refuse')?.toUpperCase()}
        </MenuItem>
      </Menu>
    </Box>
  )
}
